import { RadioGroup as FASTRadioGroup } from '@microsoft/fast-foundation';
import { foundationSegmentedControlStyles as styles } from './segmented-control.styles';
import { foundationSegmentedControlTemplate as template } from './segmented-control.template';
/**
 * @tagname %%prefix%%-segmented-control
 */
export class SegmentedControl extends FASTRadioGroup {
    valueChanged() {
        if (this.value === undefined) {
            if (this.slottedRadioButtons) {
                this.slottedRadioButtons.forEach((radio) => {
                    radio.checked = false;
                });
            }
        }
        super.valueChanged();
    }
}
// explicitly declaring for extensibility
export const foundationSegmentedControlShadowOptions = undefined;
export const defaultSegmentedControlConfig = {};
/**
 * The Foundation Segmented Control
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-segmented-control\>
 */
export const foundationSegmentedControl = SegmentedControl.compose(Object.assign({ baseName: 'segmented-control', template,
    styles, shadowOptions: foundationSegmentedControlShadowOptions }, defaultSegmentedControlConfig));
